export default "__VITE_ASSET__De2kBozT__"